<div class="req-form" style="margin-bottom: 10vh;margin-top: 50px;">
    <div *ngIf="correct">
        <div [innerHTML]="model[count].cgQuestion" style="margin-bottom: 30px;margin-top: 50px;"></div>
        <div class="custom-control custom-radio" style="margin-top: 50px;">
            <input type="radio" id="UdfRadio1" name="UdfRadio" class="custom-control-input" [formControl]="gateAnswer"
                value="Yes">
            <label class="custom-control-label" for="UdfRadio1">Yes</label>
        </div>
        <div class="custom-control custom-radio">
            <input type="radio" id="UdfRadio2" name="UdfRadio" class="custom-control-input" [formControl]="gateAnswer"
                value="No">
            <label class="custom-control-label" for="UdfRadio2">No</label>
        </div>
    </div>
    <div *ngIf="!correct">
        <div [innerHTML]="model[count].cgWrongAnswerMsg" style="margin-bottom: 30px;"></div>
    </div>
</div>